export default __webpack_public_path__ + "static/media/border.52ea10bf.png";